import React from 'react';
import PropTypes from 'prop-types';
import CommonSearch from './commonSearch';
import ExpandSearch from './expandSearch';

class Search extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        expand: PropTypes.bool,
        isIE78: PropTypes.bool,
    };

    static defaultProps = {
        expand: false,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, expand, isIE78, defaultIsExpand } = this.props;
        const search = expand ? <ExpandSearch isIE78={isIE78} content={content} defaultIsExpand={defaultIsExpand} /> : <CommonSearch content={content} />;

        return search;
    }
}

export { Search };
export default Search;
